import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { apiList } from './apiList';
import { NotificationsResponse } from '../models/notification.model';

@Injectable({
  providedIn: 'root',
})
export class notificationsService {
  constructor(
    private readonly http: HttpClient,
    private _apiList: apiList
  ) {}

  getNotifications(query: string): Observable<NotificationsResponse> {
    return this.http
      .get<{
        data: NotificationsResponse;
      }>(`${this._apiList.notifications}?${query}`)
      .pipe(map(res => res.data));
  }

  viewNotification(query: string): Observable<NotificationsResponse> {
    return this.http
      .patch<NotificationsResponse>(
        `${this._apiList.notifications}/${query}`,
        {}
      )
      .pipe(map(res => res));
  }
}
